import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getMyCommonPartsAvailableForJob(machineModelId) {
            var meta = {
                clientApiMethod: 'getCommonParts',
                input: { machineId: machineModelId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "parts/my-common-machinemodel/" + machineModelId, { meta: meta });
            return response.data;
        },
        async getMyCommonPartsAvailableForMachineJob(machineJobId) {
            var meta = {
                clientApiMethod: 'getCommonParts',
                input: { machineId: machineJobId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "parts/my-common-machinejob/" + machineJobId, { meta: meta });
            return response.data;
        },
        async getPart(articleNumber, jobId, customerNumber, machineId) {
            if (!articleNumber) return null;
            var meta = {
                clientApiMethod: 'getPart',
                input: { articleNumber },
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => event.response.data.Message
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "parts/?articleNumber=" + encodeURIComponent(articleNumber) + `&jobId=${jobId ?? ''}&customerNumber=${customerNumber ?? ''}&machineId=${machineId ?? ''}`, { meta: meta });

            return response.data;
        },
        
        async getOrderView(jobId) {
            var meta = {
                clientApiMethod: 'getPartsFromJob',
                input: { jobId: jobId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "order/job/" + jobId, { meta: meta });
            return response.data;
        },
        async getPartsFromJob(jobId) {
            var meta = {
                clientApiMethod: 'getPartsFromJob',
                input: { jobId: jobId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "parts/job-parts/" + jobId, { meta: meta });
            return response.data;
        },
        async getJobPart(partId) {
            var meta = {
                clientApiMethod: 'getPartsFromJob',
                input: { partId: partId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "parts/job-part/" + partId, { meta: meta });
            return response.data;
        },
        async getCustomerPrice(customerId, articleNumber, machineId = "", childJobId = "") {
            // todo: error handling
            if (!customerId || !articleNumber) return 0;

            var meta = {
                clientApiMethod: 'getCustomerPrice',
                input: {
                    customerId,
                    articleNumber,
                    machineId,
                    childJobId
                },
            }
            var response = await client()
                .get(`${store.state.apiRouteRoot}parts/customer-price/${customerId}?articleNumber=${articleNumber}&machineId=${machineId}&childJobId=${childJobId}`, { meta: meta });
            return response.data;
        },
        async addPartOrder(part) {
            //todo: client validation
            var meta = {
                clientApiMethod: 'addPartOrder',
                input: part,
            }
            var response = await client()
                .post(`${store.state.apiRouteRoot}parts/add-part`, part, { meta: meta });
            return response.data;
        },
        async updateJobPart(payload) {
            //todo: client validation
            var meta = {
                clientApiMethod: 'updateJobPart',
                input: payload,
                successText: i18n.t("servicesystem.responses.changed_object",
                    { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client()
                .post(`${store.state.apiRouteRoot}parts/update-part`, payload, { meta: meta });
            return response.data;
        }
    }
}